import { z } from "zod";
import { splitPhonePrefix } from "./phone-prefix";

export const NET4_FIELD_LIMITS = {
  companyName: 40,
  cif: 16,
  address: 40,
  city: 30,
  phone: 15,
  website: 40,
  swift: 11,
  contactName: 100,
  contactEmail: 100,
  contactRole: 60,
  centerName: 40,
  contactDocument: 12,
  activity: 60,
  accountNumber: 11,
  securitySocialNumber: 12,
  centerPostalCode: 10,
} as const;

export const net4LengthMessage = (maximum: number) =>
  `NET4 admite un máximo de ${maximum} caracteres.`;

export const net4TextSchema = (maximum: number) =>
  z.string().trim().max(maximum, net4LengthMessage(maximum));

export const compactNet4Phone = (value: string): string => value.replace(/\s/g, "");

export const net4PhoneSchema = z.string().trim().refine(
  (value) => {
    const { prefix, number } = splitPhonePrefix(value);
    return !/^(?:\+|00)/.test(value) || Boolean(prefix) && !/^(?:\+|00)/.test(number);
  },
  "El prefijo internacional no es válido. Revisa el teléfono.",
).refine(
  (value) => {
    const { prefix, number } = splitPhonePrefix(value);
    return !prefix || /\d/.test(number);
  },
  "Introduce un número de teléfono, no solo el prefijo.",
).refine(
  (value) => compactNet4Phone(value).length <= NET4_FIELD_LIMITS.phone,
  "NET4 admite un máximo de 15 caracteres en el teléfono.",
);
